import { createStore, sample } from 'effector'

import { $desktop, $mobile } from './screen'
import { setup } from './setup'

const $sequoia = createStore<boolean>(false)

sample({
  clock: setup,
  fn: () => navigator.userAgent.includes('Sequoia'),
  target: $sequoia,
})

export const $$device = { $mobile, $desktop, $sequoia, setup }
